module.exports = __webpack_public_path__ + "./fonts/SegoeUIRegular.ttf";